var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoalPlanning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: 245.256,
    viewBox: "0 0 331.162 245.256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3117",
    "data-name": "Group 3117",
    transform: "translate(-90.838 -2164.744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2074",
    "data-name": "Rectangle 2074",
    transform: "translate(91 2184)",
    fill: "#fff",
    stroke: "#e6e7e8",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 70,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 158,
    height: 68,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2075",
    "data-name": "Rectangle 2075",
    width: 160,
    height: 70,
    transform: "translate(262 2184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2076",
    "data-name": "Rectangle 2076",
    width: 74.799,
    height: 22.41,
    transform: "translate(91 2289)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("text", {
    id: "Click_to_Call",
    "data-name": "Click to Call",
    transform: "translate(213.743 2325)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -26.145,
    y: 0
  }, "Click to Call")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2077",
    "data-name": "Rectangle 2077",
    width: 74.799,
    height: 22.41,
    transform: "translate(176.201 2289)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("text", {
    id: "Click_to_Call-2",
    "data-name": "Click to Call",
    transform: "translate(213.743 2407)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -26.145,
    y: 0
  }, "Click to Call")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2078",
    "data-name": "Rectangle 2078",
    width: 74.799,
    height: 22.41,
    transform: "translate(261.201 2289)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("text", {
    id: "_30_",
    "data-name": "30%",
    transform: "translate(213.743 2304)",
    fill: "#7f7f7f",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.988,
    y: 0
  }, "30%")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2079",
    "data-name": "Rectangle 2079",
    width: 74.799,
    height: 22.41,
    transform: "translate(346.5 2289)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("text", {
    id: "_17_",
    "data-name": "17%",
    transform: "translate(213.743 2386)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 0
  }, "17%")), /*#__PURE__*/React.createElement("text", {
    id: "Price_Per_Click",
    "data-name": "Price Per Click",
    transform: "translate(127.743 2325)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -32.129,
    y: 0
  }, "Price Per Click")), /*#__PURE__*/React.createElement("text", {
    id: "Price_Per_Click-2",
    "data-name": "Price Per Click",
    transform: "translate(127.743 2407)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -32.129,
    y: 0
  }, "Price Per Click")), /*#__PURE__*/React.createElement("text", {
    id: "_5.00",
    "data-name": "$5.00",
    transform: "translate(127.743 2304)",
    fill: "#7f7f7f",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17.565,
    y: 0
  }, "$5.00")), /*#__PURE__*/React.createElement("text", {
    id: "_5.27",
    "data-name": "$5.27",
    transform: "translate(127.743 2386)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.056,
    y: 0
  }, "$5.27")), /*#__PURE__*/React.createElement("text", {
    id: "_8",
    "data-name": 8,
    transform: "translate(171 2229)",
    fill: "#b94f4f",
    fontSize: 27,
    fontFamily: "Montserrat-Regular, Montserrat"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.613,
    y: 0
  }, "8")), /*#__PURE__*/React.createElement("text", {
    id: "_591",
    "data-name": "$591",
    transform: "translate(342 2229)",
    fill: "#107889",
    fontSize: 27,
    fontFamily: "Montserrat-Regular, Montserrat"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -29.012,
    y: 0
  }, "$591")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2080",
    "data-name": "Rectangle 2080",
    width: 74.799,
    height: 22.41,
    transform: "translate(91 2371)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2081",
    "data-name": "Rectangle 2081",
    width: 74.799,
    height: 22.41,
    transform: "translate(176.201 2371)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2082",
    "data-name": "Rectangle 2082",
    width: 74.799,
    height: 22.41,
    transform: "translate(261.201 2371)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("text", {
    id: "New_Patients",
    "data-name": "New Patients",
    transform: "translate(384 2325)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -29.521,
    y: 0
  }, "New Patients")), /*#__PURE__*/React.createElement("text", {
    id: "_10.3",
    "data-name": 10.3,
    transform: "translate(384 2304)",
    fill: "#7f7f7f",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.634,
    y: 0
  }, "10.3")), /*#__PURE__*/React.createElement("text", {
    id: "Call_Conv.",
    "data-name": "Call Conv.",
    transform: "translate(300.795 2325)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.98,
    y: 0
  }, "Call Conv.")), /*#__PURE__*/React.createElement("text", {
    id: "Call_Conv.-2",
    "data-name": "Call Conv.",
    transform: "translate(300.795 2407)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.98,
    y: 0
  }, "Call Conv.")), /*#__PURE__*/React.createElement("text", {
    id: "_21_",
    "data-name": "21%",
    transform: "translate(300.795 2304)",
    fill: "#7f7f7f",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.988,
    y: 0
  }, "21%")), /*#__PURE__*/React.createElement("text", {
    id: "_19_",
    "data-name": "19%",
    transform: "translate(300.795 2386)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 0
  }, "19%")), /*#__PURE__*/React.createElement("text", {
    id: "Based_on_a_cumulative_of_your_monthly_averages:",
    "data-name": "Based on a cumulative of your monthly averages:",
    transform: "translate(90.838 2278.35)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Based on a cumulative of "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, "your monthly averages:")), /*#__PURE__*/React.createElement("text", {
    id: "National_Averages:",
    "data-name": "National Averages:",
    transform: "translate(90.838 2360.35)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "National Averages:")), /*#__PURE__*/React.createElement("text", {
    id: "New_Patient_Goal",
    "data-name": "New Patient Goal",
    transform: "translate(91 2177.744)",
    fill: "#b94f4f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "New Patient Goal")), /*#__PURE__*/React.createElement("text", {
    id: "Probable_Required_Budget",
    "data-name": "Probable Required Budget",
    transform: "translate(262 2177.744)",
    fill: "#329998",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Probable Required Budget")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalPlanning);
export default __webpack_public_path__ + "static/media/goalPlanning.36e66e43.svg";
export { ForwardRef as ReactComponent };